import React from 'react'

const Color = () => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0 1 12 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 0 0-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 0 1 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z M 5, 11.5 a 1.5,1.5 0 1,0 3, 0 a 1.5,1.5 0 1,0 -3,0 M 8, 7.5 a 1.5,1.5 0 1,0 3, 0 a 1.5,1.5 0 1,0 -3, 0 M13, 7.5 a 1.5,1.5 0 1,0 3,0 a 1.5,1.5 0 1,0 -3,0 M 16, 11.5 a 1.5,1.5 0 1,0 3,0 a 1.5,1.5 0 1,0 -3,0 " />
  </svg>
)

export default Color
